export default __webpack_public_path__ + "static/media/icon-5.11ed0915.png";